import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";

const HIDDEN_PREFIXES = ["/admin", "/tenant", "/team-invite", "/dashboard", "/login", "/signup", "/reset-password", "/course", "/exam", "/practice", "/ai-help"];

/**
 * <FloatingAiChat /> — the "Chat with us" corner button that expands the
 * AI Companion iframe. Mounted globally in App.js. Auto-hides on admin,
 * tenant, and dedicated AI pages to avoid stacking with other widgets.
 */
export default function FloatingAiChat() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Hide on pages where a floating widget would be noisy or redundant.
  const hidden = HIDDEN_PREFIXES.some(p => pathname === p || pathname.startsWith(p + "/"));

  // Close automatically when route changes so it doesn't linger between pages.
  useEffect(() => { setOpen(false); }, [pathname]);

  if (hidden) return null;

  return (
    <div className="fixed z-[9999] right-4 bottom-4 sm:right-6 sm:bottom-6 flex flex-col items-end" data-testid="floating-ai-chat">
      {open && (
        <iframe
          src="https://muse.ai/s/ai-companion-xqxo6wxwxajixnpxi"
          title="DyNamic Tax AI Companion"
          width="380"
          height="620"
          className="mb-3 rounded-2xl bg-background"
          style={{
            border: 0,
            maxWidth: "calc(100vw - 32px)",
            maxHeight: "calc(100vh - 120px)",
            boxShadow: "0 16px 45px rgba(0,0,0,.25)",
          }}
          loading="lazy"
          allow="clipboard-write"
          data-testid="floating-ai-iframe"
        />
      )}
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold shadow-lg transition-transform hover:scale-105 bg-primary text-primary-foreground"
        data-testid="floating-ai-toggle"
        aria-label={open ? "Close AI chat" : "Open AI chat"}
      >
        {open ? <X size={16} /> : <MessageCircle size={16} />}
        {open ? "Close" : "Chat with us"}
      </button>
    </div>
  );
}
